/* @flow */
import React from 'react';
import { ListItem } from 'material-ui/List';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Avatar from 'material-ui/Avatar';

import DateTime from '../../../../components/DateTime';
import Duration from '../../../../components/Duration';

type Props = {
  node: any,
};

const TutorJobOffer = ({ node }: Props) => {
  const { sessions, jobRequest } = node;
  const { grade, subject, student } = jobRequest;
  const { firstname, lastname, profilePictureThumbnailUri } = student;
  return (
    <ListItem
      key={node.id}
      leftAvatar={<Avatar src={profilePictureThumbnailUri} />}
      rightIcon={<ActionInfo />}
      primaryText={`${subject.name} (${grade.name}) with ${firstname} ${
        lastname
      }`}
      secondaryText={
        <div>
          {sessions.map(({ timeSlot }) => (
            <span key={timeSlot.id}>
              <Duration {...timeSlot.duration} />{' '}
              <DateTime value={timeSlot.startDate} />
            </span>
          ))}
        </div>
      }
    />
  );
};

export default TutorJobOffer;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/job/TutorJobOffer.js